import { Box, Button, Accordion, AccordionPanel } from "grommet";
import { Citation, SidebarHeading, MinorDescription, MajorDescription, Instructions } from "../../task-specific/content/descriptions";
import FileUploadComponent from "../upload/upload-ecg";

export interface ResearchDescriptionProps {
  handleUploadSliders(upload_values: Array<number>): void;
}

export function ResearchDescription({ handleUploadSliders }: ResearchDescriptionProps): React.ReactElement {
  return (
    <Box gap="small">
      <SidebarHeading />
      <Box overflow="scroll">
        <MajorDescription />
        <Accordion>
          <AccordionPanel label="Background">
            <Box pad="medium" background="light-2">
              <MinorDescription />
            </Box>
          </AccordionPanel>
          <AccordionPanel label="Instructions">
            <Box pad="medium" background="light-2">
              <Instructions />
            </Box>
          </AccordionPanel>
          <AccordionPanel label="Upload your own ECG">
            <Box pad="medium" background="light-2">
              <FileUploadComponent handleUploadSliders={handleUploadSliders} />
            </Box>
          </AccordionPanel>
          <AccordionPanel label="Other tools and source code">
            <Box pad="medium" background="light-2" direction="row" gap="small" wrap>
              <Button primary label="Reduced EF" href="https://decoder.ecgx.ai" margin={{ bottom: "small" }} />
              <Button primary label="DCM" href="https://dcm.ecgx.ai" margin={{ bottom: "small" }} />
              <Button primary label="CRT" href="https://crt.ecgx.ai" margin={{ bottom: "small" }} />
              <Button primary label="Batch encoder" href="https://encoder.ecgx.ai" margin={{ bottom: "small" }} />
              <Button primary label="Source" href="https://github.com/rutgervandeleur/ecgxai" margin={{ bottom: "small" }} />
            </Box>
          </AccordionPanel>
          <AccordionPanel label="Reference">
            <Box pad="medium" background="light-2">
              <Citation />
            </Box>
          </AccordionPanel>
        </Accordion>
      </Box>
    </Box>
  );
}
